import { cn } from 'lib/utils';
import PropTypes from 'prop-types';
import Keyword from './keyword';

const KeywordTable = ({ className, commands, description, section, title }) => {
  return (
    <div className="mb-10">
      <div
        className={cn(className, 'col-span-2 mb-4 text-center')}
        id={section}
      >
        {title && <h2>{title}</h2>}
        {description && <p>{description}</p>}
      </div>
      <dl className="grid gap-2 sm:auto-cols-auto sm:grid-flow-col sm:gap-4">
        {commands.map((command) => (
          <Keyword key={command.keyword} {...command} />
        ))}
      </dl>
    </div>
  );
};

KeywordTable.propTypes = {
  className: PropTypes.string,
  commands: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  description: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
};

export default KeywordTable;
